// Careful this may produce a conflicting property!
export const flattenProperty = (obj, prop) => {
  let copy = Object.assign({}, obj);
  Object.keys(copy[prop]).forEach(key => {
    copy[key] = copy[prop][key];
  });
  delete copy[prop];

  return copy;
};